<template>
    <BreadCrumb PageTitle="Liste des types de paiement de fret" />
    <ListeTypeFretPaiement/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypeFretPaiement from "@/components/TypeFretPaiement/ListeTypeFretPaiement.vue";
  
    export default defineComponent({
      name: "ListeTypeFretPaiePage",
      components: {
        BreadCrumb,
        ListeTypeFretPaiement,
      },
    });
  </script>